import * as React from 'react';
import Component from '../../Component';
import Item from './Item';
import Error from '../../Components/Error';
import { STATUS } from '../../General';

export default class List extends Component {

    render() {
        const offices = this.props.offices;
        switch (offices.status) {
            case STATUS.LOADING:
                return this.renderLoading();
            case STATUS.READY: {
                if (offices.arr.length === 0) {
                    const t = this.translate();
                    return (
                        <div className="col-12 text-danger mb-3">
                            {t('no.offices.found')}
                        </div>
                    );
                }
                return offices.arr.map((office: any) => {
                    return (
                        <div
                            key={'Offices' + this.props.viewMode + '-' + office.id}
                            className={this.getListColSize(this.props.viewMode) + ' mb-3'}
                        >
                            <Item
                                office={office}
                                onRefresh={() => { if (this.props.onRefresh) { this.props.onRefresh(); } }}
                            />
                        </div>
                    );
                });
            }
            default:
                return (<Error />);
        }
    }
}